import {
  getBaseProductSchema,
  ItemTypeEnum,
  ProductTypeEnum,
  retentionWireItemSchema,
  type RetentionWireProduct,
} from "@jasper/client-models";
import z from "zod";
import {
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { ArchStep } from "./constants";

export type RetentionWireStepKey = typeof StepKeysEnum.arch;

/**
 * `min(1)` and not `length(1)`: a retention wire created by V1 on both arches holds two
 * items on a single product, and must stay readable and editable from V2.
 */
const retentionWireArchesSchema = z.object({
  items: z.array(retentionWireItemSchema).min(1),
});

export const RetentionWireWorkflowConfiguration: ProductWorkflowConfiguration<
  RetentionWireProduct,
  RetentionWireStepKey
> = {
  productType: ProductTypeEnum.retentionWire,
  itemType: ItemTypeEnum.retentionWire,
  steps: [new ArchStep()],
  teethSelection: TeethSelectionEnum.ARCH,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({
      itemSchema: retentionWireItemSchema,
    }).safeParse(product).success;
  },

  getCompletedSteps(product) {
    return retentionWireArchesSchema.safeParse(product).success
      ? [StepKeysEnum.arch]
      : [];
  },
};
